import { format, isValid, parseISO } from 'date-fns';

/** Formats contract start/end dates for display (e.g. "May 1, 2027"). */
export function formatContractDate(value: string | undefined | null): string {
    if (!value) return '';
    const datePart = value.length >= 10 ? value.slice(0, 10) : value;
    const parsed = parseISO(datePart);
    if (!isValid(parsed)) return datePart;
    return format(parsed, 'MMM d, yyyy');
}
